import { usePeriodo, perLabel } from "@/lib/periodos";

// Etiqueta secundaria "· PER0X" junto a una fecha.
// Sin periodo: no renderiza nada, salvo que `fallback` esté activo (entonces muestra "· —").
export function PeriodoTag({ date, className = "", fallback = false }) {
  const p = usePeriodo(date);
  if (!p) {
    return fallback ? <span className={`text-[11px] font-semibold text-slate-400 ml-1 ${className}`} data-testid="periodo-tag">· —</span> : null;
  }
  return (
    <span className={`text-[11px] font-semibold text-blue-600 ml-1 ${className}`} data-testid="periodo-tag" title={`Periodo ${perLabel(p)} · ${p.start_date} a ${p.end_date}`}>
      · {perLabel(p)}
    </span>
  );
}
